document.addEventListener("DOMContentLoaded", function () {
  const wishlistKey = "my_wishlist";

  function getWishlist() {
    return JSON.parse(localStorage.getItem(wishlistKey)) || [];
  }

  function saveWishlist(wishlist) {
    localStorage.setItem(wishlistKey, JSON.stringify(wishlist));
  }

  function renderWishlist() {
    const wishlistContainer = document.querySelector(".wishlist-drawer__items");
    if (!wishlistContainer) return;

    const wishlist = getWishlist();
    wishlistContainer.innerHTML = "";

    if (wishlist.length === 0) {
      wishlistContainer.innerHTML = "<p>Your wishlist is empty</p>";
      return;
    }

    wishlist.forEach(item => {
      const productHTML = `
        <div class="wishlist-item">
          <img src="${item.image}" alt="${item.title}" width="80">
          <div style="display:flex; flex-direction: column; justify content center;";>

            <a href="/products/${item.handle}" class="button">View</a>
            <button class="remove-wishlist"  data-id="${item.id}">Remove</button>
          </div>
        </div>
      `;
      wishlistContainer.insertAdjacentHTML("beforeend", productHTML);
    });

    document.querySelectorAll(".remove-wishlist").forEach(btn => {
      btn.addEventListener("click", function () {
        let wishlist = getWishlist().filter(p => p.id != this.dataset.id);
        saveWishlist(wishlist);
        renderWishlist();
      });
    });
  }

  // Event delegation for dynamically loaded product cards
  document.body.addEventListener("click", function (e) {
    if (!e.target.closest(".wishlist-btn")) return;

    const btn = e.target.closest(".wishlist-btn");
    const wishlist = getWishlist();
    const productCard = btn.closest(".product-card");
    const product = {
      id: btn.dataset.productHandle,
      handle: btn.dataset.productHandle,
      title: productCard.querySelector(".product-title")?.innerText || "Product",
      image: productCard.querySelector("img")?.src || "",
    };

    // Toggle wishlist
    if (!wishlist.some(p => p.id == product.id)) {
      wishlist.push(product);
      btn.classList.add("active");
    } else {
      wishlist = wishlist.filter(p => p.id != product.id);
      btn.classList.remove("active");
    }

    saveWishlist(wishlist);
    renderWishlist();
  });

  renderWishlist();
});
